<template lang="pug">
  .component-client-action-buttons
    .dropdown-buttons
      EditParkingGroup(:item="item")
      DeleteParkingGroup(:item="item")

</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from 'src/maggieHelper'
import VehicleSmartEdit from 'components/backoffice/smartedits/VehicleEdit'
import AssetManagementActionButtons from './AssetManagementActionButtons'
import SwapAsset from './asset-management/SwapAsset'
import MoveAsset from './asset-management/MoveAsset'
import DismissAsset from './asset-management/DismissAsset'
import ModalReveal from '../../foundation/ModalReveal'
import SelectizeDriver from '../lists/selectize/SelectizeDriver'
import DatePicker from '../../DatePicker'
import ForceRebook from './reveal/ForceRebook'
import VehicleSlotDisableReveal from "./reveal/VehicleSlotDisableReveal";
import EditParkingGroup from "./asset-management/EditParkingGroup.vue";
import DeleteParkingGroup from "./asset-management/DeleteParkingGroup.vue";

export default {
  name: 'ParkingGroupButtons',
  components: {
    DeleteParkingGroup,
    EditParkingGroup,
    VehicleSlotDisableReveal,
    ForceRebook,
    DatePicker,
    SelectizeDriver,
    ModalReveal, DismissAsset, MoveAsset, SwapAsset, AssetManagementActionButtons, VehicleSmartEdit
  },
  data() {
    return {
      entity: null,
      start: null,
      end: null
    }
  },
  created() {


  },
  methods: {

  },
  props: ['item'],
  computed: {

  }
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ParkingGroupButtons.vue?68798e84